if (!customElements.get('bzh-light-buy-buttons')) {
  customElements.define('bzh-light-buy-buttons', class extends HTMLElement {
    connectedCallback() {
      this.addButton = this.querySelector('[name="add"]');
      this.buyButton = this.querySelector('[data-bzh-buy-now]');
      if (!this.addButton || !this.buyButton) return;
      this.syncAvailability = () => {
        this.buyButton.disabled = this.addButton.disabled || this.addButton.getAttribute('aria-disabled') === 'true';
      };
      this.observer = new MutationObserver(this.syncAvailability);
      this.observer.observe(this.addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.syncAvailability();
      this.onSubmit = (event) => {
        if (event.submitter !== this.buyButton) return;
        event.stopPropagation();
        if (this.buyButton.disabled || this.buyButton.getAttribute('aria-busy') === 'true') {
          event.preventDefault();
          return;
        }
        const quantity = event.target.elements.namedItem('quantity');
        if (quantity && !quantity.reportValidity()) {
          event.preventDefault();
          return;
        }
        // Let Shopify submit the current variant and quantity, then follow return_to.
        // Keep the submitter enabled so its return_to value is included in the POST.
        this.buyButton.setAttribute('aria-busy', 'true');
      };
      this.addEventListener('submit', this.onSubmit, true);
      this.onPageShow = () => this.buyButton.removeAttribute('aria-busy');
      window.addEventListener('pageshow', this.onPageShow);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('submit', this.onSubmit, true);
      window.removeEventListener('pageshow', this.onPageShow);
    }
  });
}
